import styles from './Feature.module.scss';
import AppImage from '../../assets/images/feature3_1.png';
import ExpressionImage1 from '../../assets/images/feature3_2_1.png';
import ExpressionImage2 from '../../assets/images/feature3_2_2.png';
import ExpressionImage3 from '../../assets/images/feature3_2_3.png';
import Cherry1 from '../../assets/images/main_cherry_1.png';
import Cherry2 from '../../assets/images/main_cherry_2.png';
import useMobile from '../../hooks/useMobile';

const Feature3 = () => {
  const { isMobile } = useMobile();

  if (isMobile)
    return (
      <div className={styles.mobile_wrapper}>
        <div className={styles.text_container}>
          <div className={styles.title}>
            연애시뮬레이션 게임같은 <br />
            비주얼 모드
          </div>
          <div className={styles.description}>
            매 번 비슷비슷한 메신저 창에서 대화하는게 지루하거나
            <br />
            몰입을 깨진 않으셨나요?
            <br />
            파르페는 비주얼 모드를 통해 마치 연애시뮬레이션
            <br />
            게임을 하듯 캐릭터와 대화할 수 있어요.
          </div>
        </div>
        <div className={styles.img_container}></div>
        <img src={AppImage} alt="app" className={styles.app} />
        <img src={Cherry1} alt="cherry" className={styles.cherry3_1} />
        <img src={Cherry2} alt="cherry" className={styles.cherry3_2} />
        <div
          className={styles.chip_container}
          style={{
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          <img src={ExpressionImage1} alt="expression" />
          <img src={ExpressionImage2} alt="expression" />
          <img src={ExpressionImage3} alt="expression" />
        </div>
      </div>
    );

  return (
    <div className={styles.wrapper}>
      <img src={AppImage} alt="app" className={styles.app3} />
      <img src={Cherry1} alt="cherry" className={styles.cherry3_1} />
      <img src={Cherry2} alt="cherry" className={styles.cherry3_2} />
      <div
        className={styles.container}
        style={{
          width: '40%',
        }}
      ></div>
      <div
        className={styles.container}
        style={{
          width: '60%',
        }}
      >
        <div className={styles.title}>연애시뮬레이션 게임같은 비주얼 모드</div>
        <div className={styles.description}>
          매 번 비슷비슷한 메신저 창에서 대화하는게 지루하거나 몰입을 깨진
          않으셨나요?
          <br />
          파르페는 비주얼 모드를 통해 마치 연애시뮬레이션 게임을 하듯 캐릭터와
          대화할 수 있어요.
        </div>
        <div className={styles.image_container}>
          <div className={styles.expression_container}>
            <img
              src={ExpressionImage1}
              alt="expression"
              className={styles.expression}
            />
            <p>기쁨</p>
          </div>
          <div className={styles.expression_container}>
            <img
              src={ExpressionImage2}
              alt="expression"
              className={styles.expression}
            />
            <p>당황</p>
          </div>
          <div className={styles.expression_container}>
            <img
              src={ExpressionImage3}
              alt="expression"
              className={styles.expression}
            />
            <p>화남</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature3;
